import tools from "../../../../assets/javascript/tools.js";
export default {
    columns: {
        customerName: {
            label: "姓名",
            visible: true,
            width: "auto",
            align: "left",
        },
        mobile: {
            label: "联系方式",
            visible: true,
            width: "auto",
            align: "left",
        },

        cardOldIdCn: {
            label: "套餐名称",
            visible: true,
            minWidth: "200",
            align: "left",
        },
        customerNo: {
            label: "编号",
            visible: true,
            width: "auto",
            align: "left",
        },
        originNum: {
            label: "登记次数",
            visible: true,
            width: "auto",
            align: "left",
        },
        useNum: {
            label: "使用次数",
            visible: true,
            width: "auto",
            align: "left",
        },
        oxCtime: {
            label: "创建时间",
            visible: true,
            width: "auto",
            formatDay: true,
            align: "left",
        },
    },
};